<template>
  <b-row>
    <b-col lg="12" style="min-height: 500px">
      <iframe
        v-if="type == 'voice_lectures' || type == 'interactive_video_lectures'"
        ref="myIframe"
        :src="src"
        style="width: 100%; height: 800px"
        frameborder="0"
      ></iframe>
      <b-form-file
        v-else
        v-model="file"
        placeholder="اختيار ملف أو تسقطها هنا ..."
        drop-placeholder="إسقاط الملف هنا ..."
        :accept="accept"
        @change="previewImage($event)"
      />
    </b-col>
  </b-row>
</template>

<script>
import config from "@/config/config";

export default {
  props: ["type", "accept"],
  mounted() {
    // Here we have the object of iframe

    window.addEventListener("message", this.handleMessage);
    if (
      this.type == "voice_lectures" ||
      this.type == "interactive_video_lectures"
    ) {
      this.iframeWin = this.$refs.myIframe.contentWindow;
    }
  },
  data() {
    return {
      src: config.serverUrl + "/editor?type="+this.type,
      iframeWin: {},
      file: {},
      h5p_content_id: 0,
    };
  },
  methods: {
    handleMessage(event) {
      if (event.data.cmd) {
        this.h5p_content_id = event.data.params.contentId;
      }
    },
    returnData() {
      if (
        this.file == "" ||
        (this.h5p_content_id == 0 &&
          (this.type == "voice_lectures" ||
            this.type == "interactive_video_lectures"))
      )
        return { valid: false };
      return {
        valid: true,
        file: this.file,
        h5p_content_id: this.h5p_content_id,
      };
    },
    previewImage(event) {
      const _file = event.target.files[0];

      this.file = _file;
    },
  },
  watch: {
    type: {
       immediate: true,
      handler(val, oldVal) {
        console.log("in",val);
      },
    },
  },
};
</script>

<style>
</style>